export const agentAppIconSrc = {
  home: "/images/app-icons/home.png",
  integrations: "/images/app-icons/integrations.png",
  insights: "/images/app-icons/insights.png",
  brandStudio: "/images/app-icons/brand-studio-purple.png",
  plans: "/images/app-icons/plans.png",
  skills: "/images/app-icons/skills.png",
  tasks: "/images/app-icons/tasks.png",
  siteBuilder: "/images/app-icons/site-builder.png",
  settings: "/images/app-icons/settings.png",
  abTesting: "/images/app-icons/ab-testing.png",
  reploverse: "/images/app-icons/reploverse.png",
  assets: "/images/app-icons/assets.png",
  helloWorld: "/images/app-icons/hello-world.png",
  orders: "/images/app-icons/orders.png",
  products: "/images/app-icons/products.png",
  files: "/images/app-icons/files.png",
  launchpad: "/images/app-icons/launchpad.png",
  draw: "/images/app-icons/draw.png",
  support: "/images/app-icons/support.png",
  admin: "/images/app-icons/admin.png",
} as const;
